<template>
	<div class="expanded-card">
		<h3 v-if="title">{{ title }}</h3>
		<slot></slot>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: null,
			required: false
		},
		hover: {
			type: Boolean,
			default: true
		}
	}
};
</script>
<style lang="scss" scoped>
.expanded-card {
	font-family: 'RobotoRegular';
	font-size: 15px;
	padding: 24px 32px;
	background-color: $container-bgcolor;
	color: $questionnaire-color;
	border: 1px solid $container-border;
	border-radius: 8px;
	box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);
	margin-bottom: 16px;
	line-height: 23px;

	h3 {
		min-height: 26px;
		width: auto;
		margin-top: 0px;
		margin-bottom: 8px;
		@media (min-width: $breakpoint-mid) {
			margin-bottom: 16px;
		}
	}

	@media (min-width: $breakpoint-mid) {
		padding: 32px 64px;
		font-size: 18px;
		line-height: 26px;
		margin-bottom: 24px;
	}
}
</style>
